export default "__VITE_ASSET__CRQfLNRP__"